import React from "react";
import styled, { withTheme } from "styled-components";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";

const StyledPopover = styled(Popover)`
  box-shadow: 0px 3px 6px #0000004d;
  border-radius: 7px;
  border: 0;
  max-width: 350px;

  .popover-header {
    padding-bottom: 0px;
    background-color: transparent;
    border: none;
  }
`;

const CustomPopover = (props) => {
  const { show, onClose, target, children, title } = props;

  return (
    <Overlay
      show={show}
      target={target}
      placement="bottom"
      containerPadding={20}
      rootClose
      onHide={onClose}
    >
      <StyledPopover id="popover-contained">
        <Popover.Header as="h3">{title}</Popover.Header>
        <Popover.Body>{children}</Popover.Body>
      </StyledPopover>
    </Overlay>
  );
};

export default withTheme(CustomPopover);
